import {
    Component,
    Input,
  } from '@angular/core';
@Component({
    selector: 'schools',
    templateUrl: 'schools.template.html',
    standalone: false
})

  export class SchoolsComponent {
  @Input() list: Object[];

}
